import { Action } from '@ngrx/store';
import { ILanguages } from 'src/app/models/languages.interface';

export enum ELanguagestActions {
  GetLanguages = '[Languages] Get Languages',
  GetLanguagesSuccess = '[Languages] Get Languages Success'
}

export class GetLanguages implements Action {
  public readonly type = ELanguagestActions.GetLanguages;
}

export class GetLanguagesSuccess implements Action {
  public readonly type = ELanguagestActions.GetLanguagesSuccess;
  constructor(public payload: ILanguages) {}
}

export type LanguagesActions =
  | GetLanguages
  | GetLanguagesSuccess;

